import {FeatureFlagsReducer} from './feature-flag-reducer';

export const SettingsState = {
    featureFlags: FeatureFlagsReducer
};
